import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";

var styles = {
  tableHeading: {
    paddingLeft: '2.4rem',
    textTransform: 'initial',
    fontSize: '1.6rem',
    borderBottom: "0.2rem solid ".concat(colors.neutral[600])
  },
  attributeHeading: {
    width: '25rem'
  },
  contentColumn: {
    borderLeft: "2px solid ".concat(colors.neutral[300]),
    paddingLeft: '1.6rem'
  },
  tableHeader: {
    borderBottom: 'none'
  },
  nameWrapper: {
    padding: '1rem',
    alignItems: 'center',
    borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
    display: 'flex',
    justifyContent: 'center'
  },
  variantsHeadings: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  actionButton: { width: '28.5rem' },
  configureButton: {
    marginTop: '2rem',
    width: '28.5rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map